import { render, staticRenderFns } from "./MyFormItem.vue?vue&type=template&id=e526f6e8&scoped=true&"
import script from "./MyFormItem.vue?vue&type=script&lang=ts&"
export * from "./MyFormItem.vue?vue&type=script&lang=ts&"
import style0 from "./MyFormItem.vue?vue&type=style&index=0&id=e526f6e8&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e526f6e8",
  null
  
)

export default component.exports